function Resto (){

    return(
         <article>
              <div>
                  <p className="ul-list">  <img src="/img/icons/blue-arrow.svg" className="blue-arr" /> Serveur</p>
                  <p className="ul-list">  <img src="/img/icons/blue-arrow.svg" className="blue-arr" /> Barman</p>
                  <p className="ul-list">  <img src="/img/icons/blue-arrow.svg" className="blue-arr" /> Accueil de salon</p>
                  <p className="ul-list">  <img src="/img/icons/blue-arrow.svg" className="blue-arr" /> Conseiller de vente en boulangerie</p>
                  <p className="ul-list">  <img src="/img/icons/blue-arrow.svg" className="blue-arr" /> Conseiller de vente en sommelerie</p>
                  <p className="ul-list">  <img src="/img/icons/blue-arrow.svg" className="blue-arr" /> Room service</p>
                  <p className="ul-list">  <img src="/img/icons/blue-arrow.svg" className="blue-arr" /> Tenue et clôture de caisse (VG)</p>
                  <p className="ul-list">  <img src="/img/icons/blue-arrow.svg" className="blue-arr" /> Hôte d’accueil</p>
                  <p className="ul-list">  <img src="/img/icons/blue-arrow.svg" className="blue-arr" /> Cuisinier</p>
              </div>
            </article>
    )
}

export default Resto